import customHeaders, { getSpace } from '../../common/headers';
import { useDataTable } from '../../common/hooks';
import {
  Tabs,
  TableBox,
  ButtonBasic,
  RangeBox,
  DropDownSelector,
  LineChart,
  DropContainer
} from '@lk-gtcom/ecomlab-components';
import { useEffect, useState, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { KonstantinMasterHttps } from './../../fetchUrls';
import { ArtemBilling2Https } from '../../fetchUrls';
import { useChartData } from '../../common/hooks';
import copy_icon from './img/bx-copy.svg';
import download from './img/download.svg'
import useGeneralStore from '../../store/general';
import './ReferralProgram.scss';
import { ButtonWithIcon } from '../../components/Buttons/ButtonWithIcon/ButtonWithIcon';
import { TitlePage } from '../../components/TitlePage/TitlePage';
import { periodWeek } from '../../common/constant';
import { useResponseHandler } from '../../common/auth';

const summaryColors = ['#0C2037', '#51CA64', '#F88600', '#365EFF'];

const tabs = [
  { label: 'Начисления', value: 'accruals' },
  { label: 'Выплаты', value: 'payout' },
  { label: 'Посещения', value: 'detailed_accruals' },
];

const options_period = [
  { label: 'По дням', value: 'day' },
  { label: 'По неделям', value: 'week' },
  { label: 'По месяцам', value: 'month' },
];

const CopyTextBlock = ({ title, text, btn }) => {
  return (
    <div className="copy-text-block">
      <TitlePage
        medium
        title={title}
      />

      <div className="copy-text-block__field">
        <p className="copy-text-block__text">{text}</p>
        <ButtonWithIcon
          onClick={(e) => navigator.clipboard.writeText(text)}
          grey
          size="s"
          icon={copy_icon}
        />
      </div>
      {btn && <ButtonBasic
        text={<div className='copy-text-block__content-btn'>
          <img src={download} />Сгенерировать креатив</div>}
        whiteGreen
        size='32px'
      />}
    </div>
  );
};

const ReferralProgram = () => {
  const selectedSpace = useGeneralStore((state) => state.selectedSpace);
  const headers = { ...customHeaders, ...getSpace(selectedSpace) };
  const { handleTableResponse, handleRequestError } = useResponseHandler();

  const [promoCode, setPromoCode] = useState('')
  const [link, setLink] = useState('')

  const [balance, setBalance] = useState(0);
  const [currency, setCurrency] = useState('.руб');

  const [pivotData, setPivotData] = useState([]);
  const paginatorRef = useRef();
  const [setTable, tableProps, setTableFuncs] = useDataTable(
    paginatorRef.current?.setTotal,
    paginatorRef
  );
  const [pageValue, setPageValue] = useState(null);

  const [date, setDate] = useState(periodWeek());
  const [selectedPeriod, setSelectedPeriod] = useState(options_period[0]);

  const [tableMetrics, setTableMetrics] = useState([])
  const [tableMetric, setTableMetric] = useState('')
  const [showDropBox, setShowDropBox] = useState(true)
  const [setChartData, chartData, setChartFuncs] = useChartData()

  const fetchPivotData = (abortController = new AbortController()) => {
    let url = `${KonstantinMasterHttps}/finance/pivot/summary-for-period`;

    const body = JSON.stringify({});

    fetch(url, { body, method: 'POST', headers, signal: abortController.signal })
      .then(handleTableResponse)
      .then((json) => setPivotData(json?.data?.map((el, ind) => ({ ...el, label: json?.headers?.[ind] }))))
      .catch(handleRequestError)
      .finally(() => {
        if (abortController.signal.aborted) return;
      });
  };

  const fetchBalanceCount = () => {
    let url = `${ArtemBilling2Https}/balance`;

    fetch(url, { method: 'GET', headers })
      .then(handleTableResponse)
      .then(({ balance, currency }) => {
        setBalance(balance?.toLocaleString());
        setCurrency(currency === 'RUB' ? 'руб.' : currency);
      })
      .catch(handleRequestError);
  };

  // Получение промокода
  const fetchGetPromocode = (abortController = new AbortController()) => {
    let url = `https://apps0.ecomru.ru:4430/web/referral/promo-code`;

    fetch(url, { headers, signal: abortController.signal })
      .then(handleTableResponse)
      .then((json) => setPromoCode(json?.promo_code || ''))
      .catch(handleRequestError)
  };

  // Получение ссылки
  const fetchGetLink = (abortController = new AbortController()) => {
    let url = `https://apps0.ecomru.ru:4430/web/referral/link`;

    fetch(url, { headers, signal: abortController.signal })
      .then(handleTableResponse)
      .then((json) => setLink(json?.link || ''))
      .catch(handleRequestError)
  };

  useEffect(() => {
    fetchGetPromocode()
    fetchGetLink()
  }, []);

  useEffect(() => {
    fetchBalanceCount();
  }, [selectedSpace]);

  useEffect(() => {
    const abortController = new AbortController();
    fetchPivotData(abortController);
    return () => abortController.abort();
  }, [selectedSpace]);

  const activeTab = useParams()['*'];
  useEffect(() => {
    setPageValue(activeTab);
  }, [activeTab]);

  return (
    <div className="referral-program">
      <div className="referral-program__header">
        <TitlePage
          title='Реферальная программа'
        />

        <div className="referral-program__balance">
          <p className="referral-program__text-label">Ваш баланс</p>
          <div className="referral-program__balance-field">
            <p className="referral-program__text-blue">
              {balance} {currency}
            </p>
          </div>
        </div>
      </div>

      <div className="referral-program__fields">
        <CopyTextBlock
          text={promoCode}
          title={'Ваш промокод'}
          // btn={btn}
        />

        <CopyTextBlock
          text={link}
          title={'Ваша реферальная ссылка'}
          // btn={btn}
        />
      </div>

      <div className="referral-program__period">
        <TitlePage
          medium
          title='Сводная за период'
        />

        <div className="referral-program__items-period">
          {pivotData?.map(({ label, amount, color, symb }, ind) => {
            return (
              <div className="referral-program__item-period" key={ind + amount + label}>
                <span className="referral-program__text-period">{label}</span>
                <p
                  className="referral-program__text-sum"
                  style={{ color: summaryColors?.[ind] }}
                >
                  {symb ? symb : ''}
                  {amount?.toLocaleString()} <span>₽</span>
                </p>
              </div>
            );
          })}
        </div>
      </div>


      <Tabs tabs={tabs} pageValue={pageValue} />

      {(pageValue == 'accruals' || pageValue == 'payout') &&

        <div className='referral-program__content-table'>
          {pageValue == 'payout' && <p className='referral-program__text'>
            Для получения выплат вашего вознаграждения заполните,
            пожалуйста, один из договоров исходя из вашего статуса
            (самозанятый или юр.лицо/ИП). Шаблоны договоров в формате
            Word ниже. Далее прикрепите подпись (печать), сохраните в
            формате PDF и запросите выплату приложив файл (файл должен
            быть один, включая все приложения к договору). Оплата будет
            осуществлена на указанные реквизиты после проверки документов.
          </p>}

          {pageValue == 'payout' && <div className='referral-program__cards'>
            <div className='referral-program__card'>
              <p className='referral-program__card-text'>Договор для самозанятых</p>
              <ButtonBasic
                text={<div className='copy-text-block__content-btn'>
                  <img src={download} />Скачать</div>}
                whiteGreen
                size='32px'
                width='auto'
                minWidth='auto'
              />
            </div>

            <div className='referral-program__card'>
              <p className='referral-program__card-text'>Договор для юридических лиц</p>
              <ButtonBasic
                icon={download}
                text={'Скачать'}
                whiteGreen
                size='32px'
                width='auto'
                minWidth='auto'
              />
            </div>
          </div>}

          <div className="referral-program__table-and-filters">
            <div className="referral-program__filters">
              <DropDownSelector
                options_prop={options_period}
                state={selectedPeriod}
                setState={(e) => setSelectedPeriod(e)}
                defaultValue={selectedPeriod}
                className="connections_page_selector"
                isClearable={false}
                maxWidth='150px'
              />
              <RangeBox
                date={date}
                setDate={(e) => setDate(e)} />
            </div>
            <TableBox ref={paginatorRef} {...tableProps} paginator={true} />
          </div>
        </div>
      }

      {(pageValue == 'detailed_accruals') &&

        <DropContainer
          showDropBox={showDropBox}
          setShowDropBox={(e) => setShowDropBox(e)}
        >
          <LineChart
            {...chartData}
            selectedMetric={tableMetric}
            setSelectedMetric={setTableMetric}
            metricsList={tableMetrics}
          />

        </DropContainer >
      }

    </div>
  );
};

export { ReferralProgram };
